import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import ScmpLogoFlag from "scmp-app/components/home/header/icon-logo.svg";

export const Container = styled.footer`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  padding-block: 16px 20px;
  padding-inline: 0;
`;

export const Copyright = styled.div`
  flex: 1;

  margin-inline-start: 20px;
  padding-block: 6px;
  padding-inline: 20px 0;

  color: #000000;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 12.9px;

  border-inline-start: 1px solid #000000;
`;

export const StyledScmpLogoFlag = styled(ScmpLogoFlag)`
  inline-size: 241px;
  block-size: 25px;
`;
